var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnRepeat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5157 2.31724L10.2189 2.77241C10.9962 3.26897 11.4626 4.11034 11.4626 5.0069C11.4626 6.48276 10.233 7.66897 8.72066 7.66897H3.6607L5.1165 6.26207L4.72075 5.87586L2.61478 7.94483L4.72075 10L5.1165 9.62759L3.6607 8.2069H8.72066C10.5298 8.2069 11.9997 6.77241 11.9997 5.0069C12.0139 3.91724 11.4485 2.91034 10.5157 2.31724ZM0.551225 5.0069C0.551225 3.53103 1.78088 2.33103 3.29322 2.33103H8.35318L6.89738 3.75172L7.29313 4.12414L9.39909 2.06897L7.29313 0L6.89738 0.372414L8.35318 1.7931H3.29322C1.48407 1.7931 0 3.24138 0 5.0069C0 6.09655 0.565359 7.08965 1.4982 7.69655L1.79501 7.25517C1.01765 6.74483 0.551225 5.91724 0.551225 5.0069Z",
    fill: "#444444"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnRepeat);
export default __webpack_public_path__ + "static/media/icn_repeat.fae691c3.svg";
export { ForwardRef as ReactComponent };